"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../../constant");
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Error404 = function Error404(_ref) {
  var goBackButton = _ref.goBackButton,
    links = _ref.links;
  return /*#__PURE__*/_react.default.createElement(_styled.Wrapper, null, /*#__PURE__*/_react.default.createElement(_styled.Container, null, /*#__PURE__*/_react.default.createElement(_styled.StyledHeader, null, "40", /*#__PURE__*/_react.default.createElement(_styled.RotatedText, null, "4")), /*#__PURE__*/_react.default.createElement(_styled.StyledHr, null), /*#__PURE__*/_react.default.createElement(_styled.Alert, null, "Oops!"), /*#__PURE__*/_react.default.createElement(_styled.StyledText, null, "We can't seem to find the", /*#__PURE__*/_react.default.createElement("br", null), "page you are looking for"), /*#__PURE__*/_react.default.createElement(_styled.StyledCustomButton, {
    color: _constant.colors.VIOLET,
    onClick: goBackButton === null || goBackButton === void 0 ? void 0 : goBackButton.onClick
  }, goBackButton === null || goBackButton === void 0 ? void 0 : goBackButton.label), links.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "Here are some helpful links instead:"), /*#__PURE__*/_react.default.createElement(_styled.StyledNav, null, links.map(function (_ref2, index) {
    var label = _ref2.label,
      path = _ref2.path,
      target = _ref2.target,
      disabled = _ref2.disabled;
    return /*#__PURE__*/_react.default.createElement(_styled.StyledLink, {
      key: index,
      className: disabled ? 'disabled' : '',
      href: path,
      target: target
    }, label);
  })))));
};
Error404.propTypes = {
  goBackButton: _propTypes.default.shape({
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  }),
  links: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    path: _propTypes.default.string,
    target: _propTypes.default.string,
    disabled: _propTypes.default.bool
  }))
};
Error404.defaultProps = {
  goBackButton: null,
  links: []
};
var _default = Error404;
exports.default = _default;